import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useAddPCRSCredentials = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error adding PCRSCredentials");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({
      certificatePassword,
      pcrsUsername,
      pcrsPassword,
      vendorToken,
      certificateFile,
    }) => {
      const axiosInstance = createAxiosInstance();

      const formData = new FormData();
      formData.append("certificateFile", certificateFile);

      const response = await axiosInstance.post(
        `${tenantVal}/pcrs/credentials?certificatePassword=${certificatePassword}&pcrsUsername=${pcrsUsername}&pcrsPassword=${pcrsPassword}&vendorToken=${vendorToken}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("PCRS credentials added successfully");
      queryClient.invalidateQueries({ queryKey: ["pcrsCredentials"] });
    },
    onError: handleNetworkError,
  });
};
